import { render, staticRenderFns } from "./onlineService.vue?vue&type=template&id=1a062d28&scoped=true"
import script from "./onlineService.vue?vue&type=script&lang=ts"
export * from "./onlineService.vue?vue&type=script&lang=ts"
import style0 from "./onlineService.vue?vue&type=style&index=0&id=1a062d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a062d28",
  null
  
)

export default component.exports